export function excelPurchaseReportColumns() {
  const tyear = { key: 'tyear', header: 'År', width: 10 }
  const tmonth = { key: 'tmonth', header: 'Måned', width: 10 }
  const mainCustomerCode = { key: 'mainCustomerCode', header: 'Kundenummer', width: 15 }
  const fuelTransaction = { key: 'fuelTransaction', header: 'Drivstofftransaksjon', width: 20 }
  const amountIncVAT = { key: 'amountIncVAT', header: 'Beløp inkl. MVA', width: 15 }
  const volume = { key: 'volume', header: 'Volum', width: 15 }
  const consolidatedInvoiceAgreement = { key: 'consolidatedInvoiceAgreement', header: 'Samlefaktura', width: 15 }

  return [tyear, tmonth, mainCustomerCode, fuelTransaction, amountIncVAT, volume, consolidatedInvoiceAgreement]
}

export function excelPurchaseReportDetailsColumns() {
  const tYear = { key: 'tYear', header: 'År', width: 10 }
  const tMonth = { key: 'tMonth', header: 'Måned', width: 10 }
  const fuelTransaction = { key: 'fuelTransaction', header: 'Drivstofftransaksjon', width: 20 }
  const mainCustomerCode = { key: 'mainCustomerCode', header: 'Kundenummer', width: 15 }
  const vehicleID = { key: 'vehicleID', header: 'Kjøretøy ID', width: 15 }
  const regNo = { key: 'regNo', header: 'RegNr', width: 15 }
  const description = { key: 'description', header: 'Beskrivelse', width: 25 }
  const accountNo = { key: 'accountNo', header: 'KontoNr', width: 15 }
  const consolidatedInvoiceAgreement = { key: 'consolidatedInvoiceAgreement', header: 'Samlefaktura', width: 15 }
  const amountIncVAT = { key: 'amountincVAT', header: 'Beløp inkl. MVA', width: 15 }
  const volume = { key: 'volume', header: 'Volum', width: 15 }
  const driverName = { key: 'driverName', header: 'Fører navn', width: 20 }
  const carDescription = { key: 'carDescription', header: 'Bil beskrivelse', width: 25 }
  const consolidatedInvoiceDescription = {
    key: 'consolidatedInvoiceDescription',
    header: 'Samlefaktura',
    width: 20,
  }
  const invoiceGroupingCode = { key: 'invoiceGroupingCode', header: 'Kostnadssted', width: 20 }
  const invoiceGroupingDescription = {
    key: 'invoiceGroupingDescription',
    header: 'Kostnadssted',
    width: 25,
  }

  return [
    tYear,
    tMonth,
    fuelTransaction,
    mainCustomerCode,
    vehicleID,
    regNo,
    description,
    accountNo,
    consolidatedInvoiceAgreement,
    amountIncVAT,
    volume,
    driverName,
    carDescription,
    consolidatedInvoiceDescription,
    invoiceGroupingCode,
    invoiceGroupingDescription,
  ]
}
